import { InfoIcon, TriangleAlertIcon } from 'lucide-react';
import { type ReactNode } from 'react';

import { Alert as AlertRoot, AlertDescription, AlertTitle, AlertVariant } from '@ui/components/base/alert';
import { cn } from '@ui/lib/utils';

enum ImpactNoticeVariant {
  INFORMATIVE = 'informative',
  ENGAGING = 'engaging',
}

interface ImpactNoticeProps {
  title: ReactNode;
  children?: ReactNode;
  variant?: ImpactNoticeVariant;
  action?: ReactNode;
  className?: string;
}

const alertVariantByImpact: Record<ImpactNoticeVariant, AlertVariant> = {
  [ImpactNoticeVariant.INFORMATIVE]: AlertVariant.INFO,
  [ImpactNoticeVariant.ENGAGING]: AlertVariant.WARNING,
};

const iconByImpact: Record<ImpactNoticeVariant, ReactNode> = {
  [ImpactNoticeVariant.INFORMATIVE]: <InfoIcon />,
  [ImpactNoticeVariant.ENGAGING]: <TriangleAlertIcon />,
};

const ImpactNotice = ({
  title,
  children,
  variant = ImpactNoticeVariant.INFORMATIVE,
  action,
  className,
}: ImpactNoticeProps) => (
  <AlertRoot variant={alertVariantByImpact[variant]} className={cn('font-normal', className)} data-impact={variant}>
    {iconByImpact[variant]}
    <AlertTitle>{title}</AlertTitle>
    {children && <AlertDescription>{children}</AlertDescription>}
    {action && <div className="col-start-2 mt-1.5 flex flex-wrap items-center gap-2">{action}</div>}
  </AlertRoot>
);

export { ImpactNotice, ImpactNoticeVariant };
export type { ImpactNoticeProps };
